import { createStyles, Theme } from '@material-ui/core';
import { container, coloredShadow } from 'assets/jss/material-kit-pro-react.jsx';

const styles = (theme: Theme) =>
  createStyles({
    container,
    // @ts-ignore
    coloredShadow,
    centered: {
      display: 'flex',
      justifyContent: 'center'
    },
    /**
     * only way to control child styling for mui styles is by creating the class in the current stylesheet
     * and passing to it's children
     * we want to apply this styling only for this screen
     * https://v4.mui.com/styles/advanced/#overriding-styles-classes-prop
     */
     media: {
      height: 350,
      display: 'flex',
      position: 'relative',
      objectFit: 'contain',
      [theme.breakpoints.between('sm', 'lg')]: {
        height: 328
      },
      [theme.breakpoints.down('xs')]: {
        height: 'auto'
      }
    },

    header: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2)
    },
    imageConatiner: {
      overflow: 'hidden',
      maxHeight: 480,
      [theme.breakpoints.down('lg')]: {
        maxHeight: 450
      },
      [theme.breakpoints.down('md')]: {
        maxHeight: 400
      },
      [theme.breakpoints.down('xs')]: {
        maxHeight: 360
      }
    }
  });

export default styles;
